"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const advertising_1 = require("../../sections/advertising");
const AdvertisingContext_1 = require("../../sections/advertising/context/AdvertisingContext");
const AdvertisingPage = () => {
    return ((0, jsx_runtime_1.jsx)(AdvertisingContext_1.AdvertisingProvider, { children: (0, jsx_runtime_1.jsx)(advertising_1.Advertising, {}) }));
};
exports.AdvertisingPage = AdvertisingPage;
